import { useEffect, useState } from "react";

export const breakdownTime = (seconds) => {
  const s = Math.max(0, seconds);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: Math.floor(s % 60),
  };
};

export const formatRemaining = (seconds) => {
  if (seconds <= 0) return "Éteinte";
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const pad = (n) => String(n).padStart(2, "0");
  const parts = [];
  if (d > 0) parts.push(`${d}j`);
  parts.push(`${pad(h)}h`, `${pad(m)}m`, `${pad(s)}s`);
  return parts.join(" ");
};

// Live ticking countdown derived from expires_at + burn_hours
export const useCountdown = (expiresAt, burnHours) => {
  const compute = () => {
    if (!expiresAt) return { remaining: 0, progress: 0, expired: true };
    const end = new Date(expiresAt).getTime();
    const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const total = (burnHours || 48) * 3600;
    return { remaining, progress: total ? Math.max(0, Math.min(1, remaining / total)) : 0, expired: remaining <= 0 };
  };
  const [state, setState] = useState(compute);
  useEffect(() => {
    setState(compute());
    const id = setInterval(() => setState(compute()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt, burnHours]);
  return state;
};
